const messages = {
  ERROR_MESSAGE: 'Ocorreu um erro inesperado, tente novamente mais tarde.',
  TIPO_ERROR: 'error',
  TIPO_INFO: 'info',
  TIPO_SUCCESS: 'success',
  TIPO_WARNING: 'warning',
  TITULO_ERROR: 'Erro',
  TITULO_NOVOS_PROCESSOS: 'Processos atualizados',
  TITULO_FINISH: 'Finalizar',
  TITULO_SUCCESS: 'Sucesso',
  TITULO_WARNING: 'Atenção',
  CAMPO_OBRIGATORIO: 'Campo obrigatório',
  CANCELAR_RESPOSTA: 'Caso prossiga a mensagem será perdida. Deseja continuar?',
  DOCUMENTO_REMOVE_CONFIRM: 'Tem certeza que deseja remover o documento?',
  CADASTRO_SALVO_SUCESSO: 'Cadastro salvo com sucesso!',
  CADASTRO_REMOVIDO_SUCESSO: 'Cadastro removido com sucesso!',
  CANCELAR_SOCIO: 'Ao cancelar, os dados do sócio serão perdidos. Tem certeza que deseja confirmar esta ação?',
  REMOVER_CADASTRO: 'Depois de removido, não será possível recuperar este cadastro. Tem certeza que deseja remover este cadastro?',

  CANCELAR_CADASTRO: 'Ao sair do cadastro, todos os dados que não foram salvos serão perdidos. Deseja confirmar esta ação?',
  AVISO_CADASTRO_LOGOUT: 'Tem certeza que deseja sair do cadastro sem salvar?',
  TITULO_IMPORTACAO_ARQUIVO: 'Importação de arquivos',
  SHAPEFILE_CONFIRM_MESSAGE: 'Selecione arquivos no formato <strong>Shapefile</strong>. <br> <br> Os arquivos <strong>shp</strong>, ' +
    '<strong>shx</strong>, <strong>dbf</strong> e <strong>prj</strong> devem estar compactados em um arquivo <strong>.zip</strong>',
  ARQUIVO_EXTENSION_FAIL: 'Extensão de arquivo não pode ser diferente de: $$',
  GEOMETRIA_REMOVE_CONFIRM: 'Tem certeza que deseja remover esta geometria?',
  PRATICA_REMOVE_CONFIRM: 'Tem certeza que deseja remover esta prática? Ela poderá ser adicionada novamente.',
  ARQUIVO_SIZE_FAIL: 'Arquivo deve ter no máximo $$MB de tamanho!',
  TOGGLE_PESSOA: 'Ao alterar o tipo de pessoa você perderá os dados preenchidos. Deseja confirmar?',
  CAMPOS_INVALIDOS: 'Verifique os campos destacados antes de prosseguir.',
  CADASTRO_FINALIZADO_SUCESSO: 'Cadastro finalizado com sucesso.',
  FINALIZAR_CADASTRO: 'Prezado usuário, ao finalizar este cadastro ainda será necessário enviá-lo ao ITERPA para iniciar o processo de regularização.' +
    '<br><br> Tem certeza que deseja confirmar esta ação?',
  ERRO_FINALIZAR_CADASTRO: 'Ocorreu um erro ao finalizar o cadastro. Verifique os dados ou contate o administrador do sistema.',

  SUCESSO_EXPORTACAO: 'Concluído! Cadastro enviado com sucesso',
  ERRO_PERMISSAO_USUARIO_PROCESSO: 'Permissão inválida',

  ARQUIVO_NOME_INVALIDO: 'O nome do arquivo não pode conter caracteres especiais.',

  SHAPE_INVALIDO: 'Geometria inválida.',

  LIMITES_INCORRETOS: 'Memorial descritivo fora do padrão esperado.',
  CALCULAR_LIMITES: 'Para prosseguir é necessário calcular os limites.',
  MEMORIAL_DESCRITIVO_VASIO: 'Preencha o campo memorial descritivo para calcular os limites.',
  CONFIRM_RESPOSTA_SOLICITACAO: 'Tem certeza que deseja responder essa solicitação?',
  TITULO_SUCCESS_RESPOSTA_SOLICITACAO: 'Resposta enviada com sucesso',
  MSG_SUCESSO_RESPOSTA_SOLICITACAO: 'A solicitação de informação foi respondida com sucesso',

  FINALIZAR_SOLICITACAO:
    'Ao finalizar esta mensagem, sua situação passará a ser "finalizada" e não será permitido novas respostas. O histórico estará disponível para visualização.',
  ENVIADO_ERRATA_TITULO: 'Processo enviado para retificação de título'

}

export default messages



// WEBPACK FOOTER //
// ./src/utils/messages.js